// extracted by mini-css-extract-plugin
module.exports = {"work":"work-module--work--33kUn","articles":"work-module--articles--28kpG"};